module.exports = "<ui-form-element\n        [title]=\"title\"\n        [boldTitle]=\"true\"\n        [description]=\"description\"\n        [highlightPhrase]=\"highlightPhrase\">\n</ui-form-element>\n\n\n<div class=\"radio-group\">\n    <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/form-elements/fe-radio-group/fe-radio-group.html
// module id = 1078
// module chunks = 3